(() => {
  let busy = false;
  document.addEventListener('change', (event) => {
    if (!event.target.matches('.pepita-match-form select')) return;
    const option = event.target.selectedOptions[0];
    const card = event.target.closest('.pepita-match-card');
    if (option.dataset.price) card.querySelector('.pepita-match-price').textContent = option.dataset.price;
    if (option.dataset.image) {
      const image = card.querySelector('img');
      image.removeAttribute('srcset');
      image.src = option.dataset.image;
    }
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.pepita-match-form');
    if (!form) return;
    event.preventDefault();
    if (busy || !form.reportValidity()) return;
    busy = true;
    const button = form.querySelector('button');
    const label = button.textContent;
    const error = form.querySelector('.pepita-match-error');
    const drawer = form.closest('cart-drawer');
    error.hidden = true;
    button.disabled = true;
    button.textContent = form.dataset.adding;
    form.setAttribute('aria-busy', 'true');
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({items:[{id:form.elements.id.value,quantity:1}],sections:['cart-drawer','cart-icon-bubble'],sections_url:window.location.pathname})
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || form.dataset.error);
      if (!drawer || window.location.pathname.replace(/\/$/, '').endsWith('/cart')) {
        window.location.reload();
        return;
      }
      if (!data.sections?.['cart-drawer'] || !data.sections?.['cart-icon-bubble']) {
        window.location.assign(root + 'cart');
        return;
      }
      drawer.renderContents(data);
      const heading = drawer.querySelector('.drawer__heading');
      heading?.setAttribute('tabindex', '-1');
      if (typeof trapFocus === 'function') trapFocus(drawer.querySelector('#CartDrawer'), heading);
      heading?.focus();
    } catch (failure) {
      error.textContent = failure.message || form.dataset.error;
      error.hidden = false;
    } finally {
      busy = false;
      button.disabled = false;
      button.textContent = label;
      form.removeAttribute('aria-busy');
    }
  });
})();
